import React from 'react';
import { Navigate } from 'react-router-dom';
import { useToast } from '../hooks/use-toast';

/**
 * AuthorOrAdminRoute — guards a route to roles in { 'author', 'admin' }.
 * Used by /my-books which is the author's private engagement dashboard
 * and is ALSO accessible to admins (so they can see what every author sees).
 */
const AuthorOrAdminRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');
  const { toast } = useToast();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (userRole !== 'admin' && userRole !== 'author') {
    setTimeout(() => {
      toast({
        title: 'Access Denied',
        description: 'My Books is only available to authors and admins.',
        variant: 'destructive',
      });
    }, 100);
    return <Navigate to="/welcome" replace />;
  }

  return children;
};

export default AuthorOrAdminRoute;
